export default __webpack_public_path__ + "static/media/default_product_list.f3796cf5.xlsx";